export default __webpack_public_path__ + "assets/front/scss/formulaire.fd231ae1005c3c2f197134db3c3c5d1d.css";